import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";
/**
 *
 * @param {any} item object containing health blood
 */
function HealthBloodDetail({ item }) {
    return (
        <div className="row">
            <div className="col-4 bg-primary pl-5">
                <h5>Detail</h5>
            </div>
            <div className="col-12">
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                <strong>Date of Results</strong>
                            </td>
                            <td>{cleanDate(item.dateOfResult)}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                <strong>Taken By</strong>
                            </td>
                            <td>
                                <p>{item.takenBy}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                <strong>Blood Result Group</strong>
                            </td>
                            <td>
                                <ul>
                                    {item.resultGroups.map((item, idx) => (
                                        <li key={idx}>{item}</li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                <strong>Staff</strong>
                            </td>
                            <td>
                                <StaffProfileCard item={item.author} />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                <strong>Comments</strong>
                            </td>
                            <td>{item.comment}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                <strong>Attachment</strong>
                            </td>
                            <td>
                                {item.attachment ? (
                                    <>
                                        <h5 className="text-success">Download Attachment</h5>
                                        <button
                                            className="mdl-button mdl-button--primary btn-circle margin-right-10"
                                            onClick={() => {
                                                document.location.href = item.attachment;
                                            }}
                                        >
                                            <i className="material-icons">cloud_download</i> Download
                                        </button>
                                    </>
                                ) : (
                                    <span className="text-primary">No Attachment</span>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default HealthBloodDetail;
